<template>
  <ion-page>
    <ion-content color="white" class="welcome-wrapper">
      <LargeNavbar is-home :title="partnerData?.name" show-language />
      <section class="welcome-wrapper__body d-flex justify-space-center w-100">
        <div class="content d-flex flex-column justify-space-evenly h-100 align-center w-100">
          <div class="welcome-university-wrapper ion-justify-content-center">
            <section v-if="!loading && partnerContent" style="height: 500px">
              <iframe :srcdoc="partnerContent" style="height: 500px; width: 100%;border: none" title="Lodgerin"></iframe>
            </section>
            <section
              v-else
              class="d-flex justify-space-evenly align-center w-100"
              style="height: 500px"
            >
              <ion-spinner name="circles"></ion-spinner>
            </section>
          </div>
        </div>
      </section>
      <div class="welcome-wrapper__actions ion-padding">
        <ion-button
          fill="solid"
          expand="block"
          size="large"
          color="primary"
          class="text-lg text-weight-bold"
          @click="goToSignUp"
          :disabled="loading"
        >
          {{ t('welcome.createAccount') }}
        </ion-button>
        <ion-button
          fill="clear"
          class="text-lg text-underline mt-lg mb-xs"
          color="primary"
          expand="block"
          size="small"
          @click="goTo('login')"
          :disabled="loading"
        >
          {{ t('welcome.haveAnAccount') }}
        </ion-button>
      </div>
      <ion-row class="mb-sm">
        <ion-col size="12" class="d-flex justify-space-center align-center">
          <ion-label>{{ t('welcome.inAllianceWith') }}</ion-label>
          <ion-img
            class="ml-5"
            style="height: 40px"
            :src="partnerData?.logo"
            alt="University"
          ></ion-img>
        </ion-col>
      </ion-row>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonPage, IonContent, IonButton, IonRow, IonCol, IonLabel, IonImg } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { useAuth } from '@/composables/useAuth';
  import { usePartner } from '@/composables/usePartner';
  import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import LargeNavbar from '@/components/LargeNavbar.vue';

  const { t } = useI18n();
  const { goTo } = useAuth();
  const route = useRoute();

  const {
    handleGetPartnerInfoBySlug,
    handleGetPartnerWebContent,
    partnerSlug,
    partnerData,
    partnerContent,
    loading,
  } = usePartner();

  const goToSignUp = () => {
    goTo('signUp');
  };

  const getWebContent = async() => {
    if (partnerData.value?.slug) {
      await handleGetPartnerWebContent('https://www.lodgerin.com/universities/' + partnerData.value.slug);
    }
    return null;
  };

  const initialConfig = async () => {
    if (route?.params.universitySlug) {
      partnerSlug.value = (route?.params.universitySlug as string) ?? null;
      await handleGetPartnerInfoBySlug(partnerSlug.value).then(() => {
        getWebContent();
      })
    }
  };

  onMounted(() => {
    initialConfig();
  });
</script>
<style scoped lang="scss">
  .welcome-university-wrapper {
    background: #f2f2f2;
    width: 100%;
  }

  ion-skeleton-text {
    --border-radius: 9999px;
    --background: rgba(188, 0, 255, 0.065);
    --background-rgb: 188, 0, 255;
  }
</style>
